<template>
  <div
    class="q-card"
    :class="[
      variant ? `table-${variant}` : '',
      {
        'q-card--waiting': waiting,
        blink: blink,
        'cursor-not-allowed': !clickable,
      },
    ]"
  >
    <div
      class="q-head"
      role="button"
      :tabindex="clickable ? 0 : -1"
      :aria-expanded="waiting ? String(expanded) : null"
      @click="$emit('header-click')"
      @keydown.enter.prevent="$emit('header-click')"
    >
      <span class="q-chev">
        <i
          v-if="waiting"
          class="fas"
          :class="expanded ? 'fa-chevron-down' : 'fa-chevron-right'"
        ></i>
      </span>
      <span class="q-idx">{{ index + 1 }}.</span>
      <div class="q-who">
        <div class="q-name">{{ row.nameTh }}</div>
        <div v-if="row.txTitle" class="q-sub">{{ row.txTitle }}</div>
        <PatientTagBadges
          :tag-ids="row.patient && row.patient.tagIds"
          class="q-tags"
        />
      </div>
      <div class="q-meta">
        <span
          class="status-pill"
          :class="{
            'pill-onTime': row.checkinStatus == 1,
            'pill-early': row.checkinStatus == 2,
            'pill-late': row.checkinStatus == 3,
            'pill-walkIn': row.checkinStatus == 4,
          }"
          >{{ row.checkinStatusName }}</span
        >
        <img v-if="row.isNhso" class="q-nhso" :src="nhsoLogo" alt="NHSO" />
        <span v-if="row.aaci.key === 'acked'" class="status-pill pill-onTime"
          >✓ {{ ackTime }}</span
        >
        <span v-else-if="row.aaci.text" class="status-pill pill-late">{{
          row.aaci.text
        }}</span>
        <span class="q-time">นัด {{ apptTime }} · มา {{ arrivalTime }}</span>
        <b-button
          variant="outline-primary"
          size="sm"
          class="welcome-btn"
          :class="{ 'welcome-btn--active': welcomeActive }"
          title="แสดงหน้าจอต้อนรับ"
          @click.stop="$emit('welcome')"
          @keydown.enter.stop
        >
          <i class="fas fa-desktop"></i>
        </b-button>
      </div>
    </div>

    <div v-if="row.checkinNote" class="q-note">
      <i class="fas fa-comment-dots mr-1"></i>{{ row.checkinNote }}
    </div>

    <PreTreatmentAckCard
      v-if="waiting && expanded"
      :row="row"
      @acknowledged="$emit('acknowledged', row.id)"
      @refresh="$emit('refresh')"
    />
  </div>
</template>

<script>
import PreTreatmentAckCard from "@/components/aaci/PreTreatmentAckCard";
import PatientTagBadges from "@/components/aaci/PatientTagBadges";
import { isWaiting } from "@/utils/aaciQueue";

export default {
  name: "QueueCard",
  components: { PreTreatmentAckCard, PatientTagBadges },
  props: {
    row: { type: Object, required: true },
    index: { type: Number, required: true },
    expanded: { type: Boolean, default: false },
    variant: { type: String, default: "" },
    apptTime: { type: String, default: "-" },
    arrivalTime: { type: String, default: "-" },
    ackTime: { type: String, default: "" },
    clickable: { type: Boolean, default: true },
    blink: { type: Boolean, default: false },
    welcomeActive: { type: Boolean, default: false },
    nhsoLogo: { type: String, default: "" },
  },
  computed: {
    waiting() {
      return isWaiting(this.row);
    },
  },
};
</script>

<style scoped>
.q-card {
  border: 1px solid #dee2e6;
  border-radius: 6px;
  margin-bottom: 6px;
  background: #fff;
  overflow: hidden;
}
.q-card--waiting {
  border-left: 4px solid #f59f00;
}
.q-head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 6px;
  padding: 6px 8px;
  cursor: pointer;
}
.cursor-not-allowed .q-head {
  cursor: not-allowed;
}
.q-chev {
  width: 12px;
  color: #6c757d;
  font-size: 11px;
}
.q-idx {
  color: #495057;
  font-size: 14px;
}
.q-who {
  flex: 1 1 120px;
  min-width: 0;
}
.q-name {
  font-weight: 600;
  font-size: 14px;
  line-height: 1.3;
  overflow-wrap: anywhere;
}
.q-sub {
  color: #6c757d;
  font-size: 12.5px;
  line-height: 1.25;
  overflow-wrap: anywhere;
}
.q-tags {
  margin-top: 2px;
}
.q-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 4px 6px;
  margin-left: auto;
}
.q-nhso {
  width: auto;
  height: 16px;
}
.q-time {
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  font-size: 13px;
  color: #495057;
}
.q-note {
  padding: 0 8px 6px 30px;
  font-size: 13px;
  color: #1864ab;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
</style>
